<template>
  <div class="admin-wrapper">
    <nav class="om-top-nav flex sb">
      <div class="om-nav-logo">
        <img src="/static/img/logo.png" :alt="$tr('Omniway', 'Admin')">
      </div>
      <div class="om-nav-right">
        <router-link v-if="isDispatch" tag="button" class="om-nav-right__button" :to="{ name: 'ShopSettings', params: {code: 'new'}}">
          <span class="om-icon-plus">+</span>
          {{ $tr('dodaj nowy sklep', 'Admin') }}
        </router-link>
        <button class="om-logout-button" @click.prevent="logout()">
          {{ isDispatch ? $tr('Wyloguj', 'Admin') : (loggedShop !== null ? loggedShop.name : $tr('Wyloguj', 'Admin')) }}
          <img src="/static/img/logout.png" :alt="$tr('Wyloguj', 'Admin')">
        </button>
      </div>
    </nav>
    <div class="om-center">
      <img class="om-admin-big-logo" v-if="settings && settings.logo_url" :src="settings.logo_url" :alt="$tr('Omniway', 'Admin')">
      <img class="om-admin-big-logo" v-else="" src="/static/temp/logo-patrizia-aryton.png" :alt="$tr('Omniway', 'Admin')">
    </div>
    <div class="om-layout flex sb clearfix" :class="[(isDispatch ? 'om-layout--is-left-column' : '')]">
      <aside v-if="isDispatch" class="om-aside">
        <!--<router-link activeClass="active" to="/admin/order-list" class="om-aside__link">
          {{ $tr('Lista zamówień', 'Admin') }}
        </router-link>-->
        <router-link v-if="isDispatch" activeClass="active" to="/admin/return-list" class="om-aside__link">
          {{ $tr('Lista zwrotów', 'Admin') }}
        </router-link>
        <router-link v-if="isDispatch" activeClass="active" to="/admin/collect-list" class="om-aside__link">
          {{ $tr('Lista odbiorów', 'Admin') }}
        </router-link>
        <router-link v-if="isDispatch" activeClass="active" to="/admin/shop-list" class="om-aside__link">
          {{ $tr('Lista sklepów', 'Admin') }}
        </router-link>
        <!--<router-link activeClass="active" to="/admin/account" class="om-aside__link">
          {{ $tr('Konto', 'Admin') }}
        </router-link>
        <router-link activeClass="active" to="/admin/help" class="om-aside__link">
          {{ $tr('Pomoc', 'Admin') }}
        </router-link>-->
      </aside>
      <main class="om-admin-content">
        <transition name="slide" mode="out-in">
          <keep-alive :include="['order-list']">
            <router-view></router-view>
          </keep-alive>
        </transition>
      </main>
    </div>


  </div>
</template>

<script>
export default {
  name: 'admin',
  data () {
    return {
      settings: null
    }
  },
  mounted () {
    this.settings = this.$store.getters.getDispatchSettings
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  },
  computed: {
    isDispatch () {
      return this.$store.state.role === 'dispatch'
    },
    loggedShop () {
      return this.$store.getters.getShop
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "./../assets/scss/settings";
  .om-logout-button{
    cursor: pointer;
    color: $omni-color-table;
    font-family: $omni-font-family;
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    text-transform: uppercase;
    img{
      margin-left: 20px;
      vertical-align: middle;
    }
  }
  .om-nav-logo{
    padding: 17px 15px 10px 39px;
    width: 163px;
    img{
      max-width: 100%;
    }
  }
  .om-admin-big-logo{
    margin: 15px 0 48px;
  }
  .om-nav-right{
    padding: 17px 48px 10px 10px;
    &__button{
      cursor: pointer;
      color: $omni-color-table;
      font-family: $omni-font-family;
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      text-transform: uppercase;
      .om-icon-plus{
        color: $omni-color-blue;
        font-family: $omni-font-custom;
        font-size: 30px;
        font-weight: 400;
        margin: 0 10px 0 0;
        vertical-align: middle;
      }
    }
  }
  .om-layout{
    min-height: calc(100vh - 173px);
  }
</style>



// WEBPACK FOOTER //
// Admin.vue?19501890